function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import App, { AlertsBus } from 'modules/App';
import GuardianIcon from 'svg/guardian.svg';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import { useAction } from 'hooks';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import messages from '../../../messages';
import * as selectors from '../../../selectors';
import * as actions from '../../../actions';
import { EDIT_GUARDIAN_EMAIL_FORM } from '../../../constants';
import { renderHeader, renderInfo } from '../renderers';
import styles from './EditGuardianEmail.pcss';
import validatorRules from './validatorRules.json';
const EditGuardianEmail = ({ guardianEmail, setGuardianEmail })=>{
    useStyles(styles);
    const formValues = useSelector(App.selectors.formSelector(EDIT_GUARDIAN_EMAIL_FORM));
    const isInProgress = useSelector(selectors.isEditGuardianEmailInProgress);
    const editGuardianEmail = useAction(actions.editGuardianEmail);
    const setFormValue = useAction(App.actions.setFormValue, EDIT_GUARDIAN_EMAIL_FORM);
    const processForm = App.hooks.useFormProcessing(EDIT_GUARDIAN_EMAIL_FORM, (values)=>{
        const email = get(values, 'email');
        editGuardianEmail(get(values, 'email'));
        setGuardianEmail(email);
    });
    const isFormNotCompleted = App.hooks.useIsFormNotCompleted(formValues, validatorRules);
    const clearForm = useAction(App.actions.clearForm, EDIT_GUARDIAN_EMAIL_FORM);
    const onSubmit = ()=>{
        processForm(formValues, validatorRules);
    };
    useEffect(()=>()=>{
            clearForm();
        }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            renderHeader(messages.headers.editGuardianEmail),
            /*#__PURE__*/ _jsx(AlertsBus, {
                className: "mb-6"
            }),
            /*#__PURE__*/ _jsx(GuardianIcon, {
                className: "mb-6"
            }),
            renderInfo(messages.infos.editGuardianEmail, guardianEmail),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.previousEmail,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.previousEmail))
                    }),
                    /*#__PURE__*/ _jsx("b", {
                        children: guardianEmail
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Form, {
                className: "w-100",
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ _jsx(FormGroup, {
                        id: "email",
                        labelMessage: messages.labels.email,
                        formValues: formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            placeholder: messages.placeholders.email,
                            onChange: setFormValue
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        styleModifier: "primary",
                        className: "btn--block btn--filled",
                        labelMessage: App.messages.buttons.continue,
                        isInProgress: isInProgress,
                        isDisabled: isFormNotCompleted
                    })
                ]
            })
        ]
    });
};
export default EditGuardianEmail;
